export enum TagInfoEnum {
  Report,
  Image,
  Description
}
